import { render, staticRenderFns } from "./RenotificationTooltip.vue?vue&type=template&id=7fd70048&scoped=true"
import script from "./RenotificationTooltip.vue?vue&type=script&lang=js"
export * from "./RenotificationTooltip.vue?vue&type=script&lang=js"
import style0 from "./RenotificationTooltip.vue?vue&type=style&index=0&id=7fd70048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd70048",
  null
  
)

export default component.exports